import { doc, runTransaction } from 'firebase/firestore';
import { db } from './firebase';
import { applyValueEdits } from '../utils/mappingValueEdits';

// Profile aliases are a subset of the table vocabulary. Save both together so
// approval-time learning cannot prune an alias the profile editor just added.
export async function saveProfileMappingValues(companyId, tableId, profileId, edits) {
  const tableRef = doc(db, `users/${companyId}/tables/${tableId}`);
  const profileRef = doc(db, `${tableRef.path}/data_profiles/${profileId}`);
  return runTransaction(db, async (transaction) => {
    const table = await transaction.get(tableRef);
    const profile = await transaction.get(profileRef);
    if (!table.exists()) throw new Error('This table no longer exists.');
    if (!profile.exists()) throw new Error('This profile no longer exists.');
    if (table.data().status === 'Deleting') throw new Error('This table is being deleted.');

    const profileValues = applyValueEdits(profile.data().possible_values || {}, edits);
    const tableValues = { ...table.data().possible_values };
    for (const [column, aliases] of Object.entries(profileValues)) {
      // Removing a profile alias does not remove it from other profiles or the
      // table. Preserve every concurrently learned global alias as well.
      tableValues[column] = [...new Set([...(tableValues[column] || []), ...aliases])];
    }
    transaction.update(tableRef, { possible_values: tableValues });
    transaction.update(profileRef, { possible_values: profileValues });
    return profileValues;
  });
}
